import React from 'react';
import * as _ from 'lodash';
import dialogLoader from '../utilities/dialogLoader';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import Joi from 'joi-browser';
import regex from '../utilities/validateRegex';
import { validateByJoi } from '../utilities/validation';
import Helmet from 'react-helmet';
import { isTargetRoleId } from '../utilities/roleUtility';
import { HEADER_CONSTANTS, USER_ROLES, API_FLAG } from '../utilities/constants';
import { PartnerUserForm } from '../components/forms/PartnerUser'; // フォーム
import { CloseEditView } from '../components/CloseEditView.jsx';
import { CompanyBranchService } from '../services/CompanyBranches';
import ImageUtility from '../utilities/imageUtility';
import { ImageDialog } from '../components/modals/ImageDialog';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { messageUtility } from '../utilities/messageUtility';
import {
  isNullOrEmpty,
  deleteControlCode,
  formatTel,
} from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { PASSWORD_TYPES } from '../utilities/constants';
import { validatePasswordPolicy } from '../utilities/commonValidation';
import { PasswordPolicyService } from '../services/PasswordPolicyService';

// 必須項目名
// (ユーザー種別 , 所属会社は必須だが固定)
const REQUIRE_COLUMNS = [
  'login_id',
  'name_sei',
  'name_mei',
  'kana_sei',
  'kana_mei',
];

/**
 * 協力会社ユーザー詳細・詳細
 * 画面遷移
 *  1.  協力会社一覧>>ユーザー確認>>職業行の確認ボタン>>編集
 */
export class PartnerUserEdit extends React.Component {
  constructor(props) {
    super(props);

    // タイトル名
    this.TITLE_NAME = '協力会社ユーザー詳細・編集';

    // パラメータ分解
    const param = this.props.view.state.id.split('.');

    this.state = {
      partnerCompanyId: param[0], // 協力会社ID
      companyBranchId: param[1], // 支店ID
      partnerUserId: param[2], // 協力会社ユーザーID
      company: {
        name: '',
      }, // 協力会社情報
      passwordChangeable: false, // パスワード欄の表示/非表示(デフォルト：OFF)
      passwordVisible: false, // パスワードの表示/非表示
      requiredInput: {
        // 必須入力項目
        columns: REQUIRE_COLUMNS,
        // 必須総数(※"ユーザー種別", "所属会社"は必須だが固定)
        total: REQUIRE_COLUMNS.length,
        // 入力数
        count: 0,
      },
      validate: {
        validated: true, // 登録ボタン押下済み判定
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      image: {
        // アップロード画像
        file: '', // バイナリ
        path: '', // 画像URL
        isSet: false, // 画像セットフラグ
      },
      formValues: {
        user_role_code: '', // ユーザー種別
        company_id: '', // 所属会社ID
        company_name: '', // 所属会社
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        login_id: '', // ログインID
        email: '', // メールアドレス
        tel: '', // 電話番号
        company_branch_id: param[1], // 支店ID
        manager_flag: '', // 現場監督フラグ
        block_flag: '', // 使用禁止フラグ
        // パスワード系
        password: '', // パスワード
        password_confirmation: '', // パスワード確認
        is_image_updated: API_FLAG.Off,
      },
      is_image_deleted: API_FLAG.Off,
      privatePasswordPolicy: {},
    };

    // バリデーションパターン
    this.schema = Joi.object().keys({
      company_id: Joi.number().allow(null, ''), // 所属会社ID
      company_name: Joi.string().allow(null, ''), // 所属会社
      manager_flag: Joi.number().allow(null, ''), // 現場監督フラグ
      block_flag: Joi.number().allow(null, ''), // 使用禁止フラグ
      user_role_code: Joi.number().allow(null, ''), // ユーザー種別
      name_sei: Joi.string()
        .required()
        .max(64), // 姓
      name_mei: Joi.string()
        .required()
        .max(64), // 名
      kana_sei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128), // せい
      kana_mei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128), // めい
      email: Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .allow(null, ''), // メールアドレス
      password: Joi.string()
        .label('pwdPWD32')
        .regex(regex.pattern.pwdPWD32)
        .max(32)
        .required(), // パスワード
      password_confirmation: Joi.string()
        .label('pwdPWD32')
        .regex(regex.pattern.pwdPWD32)
        .max(32)
        .required(), // パスワード確認
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, '', '--'), // 電話番号
      company_branch_id: Joi.number().required(), // 支店ID
    });

    this.initForm = this.initForm.bind(this); // フォーム生成
    // 協力会社ユーザー更新
    this.submit = this.submit.bind(this);
    this.imageExists = this.imageExists.bind(this); // 画像判定

    // イベント登録
    this.events = {
      dialog: {
        // ダイアログ
        goBack: this.handleGoBack.bind(this), // 閉じる
        goUsers: this.handleGoUsers.bind(this), // 閉じる
      },
      form: {
        // フォーム関連
        set: this.setData.bind(this), // 会社情報入力
        isAvailable: this.isAvailable.bind(this), // バリデーション
        setImage: this.setImage.bind(this), // 画像アップ
        submit: this.submit.bind(this), // 登録
        deleteImage: this.deleteImage.bind(this), // 画像削除
        switchPasswordChangeable: this.switchPasswordChangeable.bind(this), // パスワード欄の表示.非表示
        switchPasswordVisible: this.switchPasswordVisible.bind(this), // パスワードの表示.非表示
      },
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          let id = `${this.state.partnerCompanyId}.${
            this.state.companyBranchId
          }.${this.state.partnerUserId}`;
          _masterSlideLoader.show('PartnerUserPreview', { state: { id } });
          dialogLoader.close();
        },
      },
    };

    // 一覧へ戻るダイアログ
    this.GoUsers = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          let id = `${this.state.partnerCompanyId}.${
            this.state.companyBranchId
          }.${this.state.partnerUserId}`;
          _masterSlideLoader.show('PartnerUsers', { state: { id } });
          dialogLoader.close();
        },
      },
    };
  }

  componentDidMount() {
    const param = {
      company_branch_id: this.state.companyBranchId,
    };

    // 協力会社情報取得
    CompanyBranchService.show(this.state.partnerCompanyId, param).then(
      response => {
        if (response.result) {
          // 協力会社情報
          const partnerCompany = response.data.entities;
          // フォームに値セット
          CompanyBranchService.companyPartnerUser(this.state.partnerUserId, {
            company_id: this.state.partnerCompanyId,
          }).then(response => {
            if (response.result) {
              this.initForm(partnerCompany, response.data.entities.user);
            }
          });
        }
      }
    );
  }

  /**
   * フォーム生成
   *
   * @param {object} partnerCompany 協力会社情報
   * @param {object} partnerUser 協力会社ユーザー情報
   * @memberof PartnerUserEdit
   */
  initForm(partnerCompany, partnerUser) {
    let formValues = this.state.formValues;
    formValues.company_name = partnerCompany.company.name;

    let image = this.state.image;
    _.each(partnerUser, (user, key) => {
      if (_.has(this.state.formValues, key)) {
        formValues[key] = _.defaultTo(user, '');
      }
    });

    // ログインID
    formValues.login_id = partnerUser.login_id;
    // ユーザーロール
    const userRoleCode = partnerUser.user_role.code;
    formValues.user_role_code = userRoleCode;
    formValues.company_id = this.state.partnerCompanyId;
    formValues.company_branch_id = this.state.companyBranchId;
    image.path = partnerUser.image_url;

    // ロールが職長かどうか
    const isForemanRole = isTargetRoleId(
      [USER_ROLES.foreman],
      parseInt(userRoleCode, 10)
    );

    if (isForemanRole) {
      // 職長
      // login_idとメールアドレスを別々に表示する職長の場合は、
      // login_idにはlogin_id用のバリデータをあててください。
      this.schema = this.schema.append({
        login_id: Joi.string()
          // エラーメッセージに出すためのものパスワードじゃないけどpwdを使っている
          .label('pwd')
          .regex(regex.pattern.pwd)
          .required()
          .max(60),
      });
    } else {
      // 職長以外は、login_id＝メールアドレスなので、
      // ユーザーID/メールアドレス欄として表示して、
      // メールアドレス用のバリデーターを当ててください。
      this.schema = this.schema.append({
        login_id: Joi.string()
          .label('email')
          .regex(regex.pattern.email)
          .max(255)
          .required(),
      });
    }

    // 必須チェック
    const requiredCountValue = this.requiredCount(
      formValues,
      { ...this.state.validate.messages },
      this.state.requiredInput.columns
    );

    this.setState({
      company: partnerCompany.company,
      image,
      formValues,
      requiredInput: { ...this.state.requiredInput, ...requiredCountValue },
    });
    this.getPasswordPolicy(userRoleCode);
  }

  async getPasswordPolicy(userRoleCode) {
    PasswordPolicyService.getPasswordPolicy(userRoleCode).then(res => {
      this.setState(
        {
          privatePasswordPolicy: res.data,
        },
        () => {
          this.setSchemaPasswordPolicy();
        }
      );
    });
  }

  setSchemaPasswordPolicy() {
    this.schema = this.schema.append({
      password: Joi.string()
        .required()
        .max(0)
        .error(err =>
          validatePasswordPolicy(err, this.state.privatePasswordPolicy)
        ),
      password_confirmation: Joi.string()
        .required()
        .max(0)
        .error(err =>
          validatePasswordPolicy(err, this.state.privatePasswordPolicy)
        ),
    });
  }

  /**
   * 戻るダイアログ表示
   */
  handleGoBack = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * 一覧へ戻るダイアログ表示
   */
  handleGoUsers = () => {
    dialogLoader.show(CloseEditView, this.GoUsers);
  };

  /**
   * 入力
   */
  setData = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = deleteControlCode(value);
    this.setState({ formValues });
  };

  /**
   * 画像アップロード
   */
  setImage = e => {
    let createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    let image = this.state.image;
    if (!e.target.files[0]) {
      return;
    }
    let url = createObjectURL(e.target.files[0]);
    this.imageExists(url, e.target, async (loaded, target) => {
      const size = await ImageUtility.fileSizeCheck(target.files[0]);
      const type = await ImageUtility.fileTypeCheck(target.files[0]);
      // filetype,filesizeをチェック、errorが無ければイメージをセット
      if (!type) {
        this.imageTypeErrorDialog();
      } else if (!size) {
        this.imageSizeErrorDialog();
      } else {
        image.path = url;
        image.file = target;
        image.isSet = true;
      }
      this.setState({ image });
    });
  };

  /**
   * 画像TypeErrorダイアログ表示
   */
  imageTypeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: '選択可能な画像形式は「JPEG、GIF、PNG」ファイルです',
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像SizeErrorダイアログ表示
   */
  imageSizeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: messageUtility.getMessage('E-000-011'),
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像判定
   * @param url {string}
   */
  imageExists(url, target, callback) {
    var img = new Image();
    img.src = url;
    img.onload = () => {
      callback(true, target);
    };
    img.onerror = () => {
      callback(false);
    };
  }

  /**
   * 画像削除
   */
  deleteImage = () => {
    let image = this.state.image;
    let is_image_deleted = true;
    image.path = '';
    image.file = '';
    image.isSet = true;
    this.setState({ image, is_image_deleted });
    // onChangeイベントを感知
    document.getElementById('file-company-branch-image').value = '';
  };

  /**
   * パスワード欄の表示/非表示
   */
  switchPasswordChangeable = () => {
    const requiredInput = this.state.requiredInput;

    // 必須項目名
    if (this.state.passwordChangeable) {
      // デフォルト
      requiredInput.columns = REQUIRE_COLUMNS;
    } else {
      // パスワードある系
      requiredInput.columns = _.concat(
        REQUIRE_COLUMNS,
        'password',
        'password_confirmation'
      );
    }

    // 必須チェック
    const requiredCountValue = this.requiredCount(
      { ...this.state.formValues },
      { ...this.state.validate.messages },
      this.state.requiredInput.columns
    );

    this.setState({
      passwordChangeable: !this.state.passwordChangeable,
      requiredInput: { ...this.state.requiredInput, ...requiredCountValue },
    });
  };

  /**
   * パスワード表示/非表示
   */
  switchPasswordVisible = () => {
    this.setState({
      passwordVisible: !this.state.passwordVisible,
    });
  };

  /**
   * 必須項目の入力状況監視
   * @param formValues {object} // 入力内容
   */
  requiredCount(formValues, messages, columns) {
    let cnt = 0;
    _.each(columns, column => {
      if (formValues[column] && !messages[column]) {
        cnt++;
      }
    });

    // 必須項目の入力数・分子
    const count = cnt;
    // 必須項目の入力数・分母
    const total = columns.length;

    return {
      count,
      total,
    };
  }

  /**
   * 入力値の有効判定
   *
   * @param {*} event
   * @param {*} targetName
   * @returns 正しい: true, 正しくない: false
   * @memberof PartnerUserEdit
   */
  isAvailable(event, targetName) {
    let formValues = { ...this.state.formValues };
    let validate = { ...this.state.validate };
    const result = validateByJoi(this.schema, formValues);
    const available = result.result;

    // エラーメッセージ（{}がないとundefinedのことがある）
    const messages = result.messages || {};

    // 独自invalid(trueなら入力間違い)
    let invalid = false;

    // パスワード表示の時だけ
    if (this.state.passwordChangeable) {
      // パスワードチェック
      if (formValues['password'] !== formValues['password_confirmation']) {
        messages['password_confirmation'] =
          'パスワードと同じ値ではありません。';
        invalid = true; // エラーにする
        result.messages = messages;
      }
    }

    // if  - onBlur時に入力チェック
    // else- submit(登録ボタン押下)時に必須項目チェック
    if (event) {
      let name = _.isEmpty(targetName) ? event.target.name : targetName;
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
        validate.invalid = true;
      } else if (_.has(validate.messages, name)) {
        delete validate.messages[name];
        validate.invalid = false;
      }
    } else {
      validate.messages = {};
      if (!available || invalid) {
        _.each(result.messages, (value, key) => {
          validate.messages[key] = result.messages[key];
        });
      }
      if (!this.state.passwordChangeable) {
        delete validate.messages['password'];
        delete validate.messages['password_confirmation'];
      }
    }

    // 必須チェック
    const requiredCountValue = this.requiredCount(
      formValues,
      { ...validate.messages },
      this.state.requiredInput.columns
    );

    // error有無チェック、フラグ変更
    if (Object.keys(validate.messages).length !== 0) {
      validate.invalid = true;
    } else {
      validate.invalid = false;
    }

    validate.invalid =
      validate.invalid || requiredCountValue.total !== requiredCountValue.count;

    this.setState({
      validate,
      requiredInput: { ...this.state.requiredInput, ...requiredCountValue },
    });

    return !validate.invalid && !invalid;
  }

  /**
   * 協力会社ユーザー更新
   */
  submit() {
    // まず入力値を確認
    if (!this.isAvailable()) {
      return;
    }

    let formValues = { ...this.state.formValues };
    // 画像セット
    if (this.state.image.isSet) {
      formValues = _.assign(formValues, { user_image: this.state.image.file });
      formValues = _.assign(formValues, { is_image_updated: API_FLAG.On });
    } else if (!this.state.image.isSet) {
      formValues = _.assign(formValues, { is_image_updated: API_FLAG.Off });
    }

    // console.log('debug', 'PartnerUserEdit.jsx submit', formValues);
    if (this.state.passwordChangeable === false) {
      // パスワードのチェックが非表示の場合
      // パスワード情報は削除する
      formValues.password = '';
      formValues.password_confirmation = '';
    }

    if (this.is_image_deleted === API_FLAG.On) {
      formValues.user_image = '';
      this.setState({ is_image_deleted: API_FLAG.On });
      formValues = _.assign(formValues, { is_image_updated: API_FLAG.On });
    }
    formValues.tel = formatTel(formValues.tel);
    formValues.password_type = PASSWORD_TYPES.COMMON_INPUT_TYPE;

    // 更新API
    CompanyBranchService.updateCompanyPartnerUser(
      this.state.partnerUserId,
      formValues
    ).then(response => {
      // 更新失敗時
      if (!response.result) {
        const updateMsgDetail = isNullOrEmpty(response.data.message)
          ? messageUtility.getMessage('E-000-005')
          : response.data.message;
        this.setState({
          showModal: true,
          updateSuccess: false,
          updateMsg: messageUtility.getMessage('E-001-402'),
          updateMsgDetail,
        });
        return;
      }

      // 成功時
      this.setState({
        showModal: true,
        updateSuccess: true,
        updateMsg: 'ユーザー更新完了',
        updateMsgDetail: 'ユーザーの更新が完了しました。',
      });
    });
  }

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.TITLE_NAME}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={`${this.state.company.name} ${this.TITLE_NAME}`}
            onClose={() => this.events.dialog.goBack()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__header'>
                  <button
                    className='btn-text--sm'
                    onClick={() => this.events.dialog.goUsers()}
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    ユーザー一覧
                  </button>
                </div>
                <div className='contruction-detail-view__menu'>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn--sub'
                      onClick={() => this.events.dialog.goBack()}
                    >
                      編集をやめる
                    </button>
                  </span>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn--effective'
                      onClick={() => this.events.form.submit()}
                    >
                      更新
                    </button>
                  </span>
                  <span
                    className='contruction-detail-view__end-item'
                    style={{
                      right: '155px',
                      color: '#E64E17',
                      fontSize: '12px',
                    }}
                  >
                    {this.state.validate.invalid
                      ? '入力エラーがあります。'
                      : ''}
                  </span>
                  <div className='contruction-detail-view__end-item'>{`必須項目の入力数 ${
                    this.state.requiredInput.count
                  }/${this.state.requiredInput.total}`}</div>
                </div>
                <div className='contruction-detail-view__bar' />
                <PartnerUserForm
                  values={this.state.formValues}
                  events={this.events.form}
                  messages={this.state.validate.messages}
                  image={this.state.image.path}
                  joiningFlag={this.state.company.joining_flag}
                  passwordChangeable={this.state.passwordChangeable}
                  passwordVisible={this.state.passwordVisible}
                  policyDescription={
                    this.state.privatePasswordPolicy.policy_description
                  }
                />
              </div>
              <Modal modalRoot='root' modalState={this.state.showModal}>
                <DialogSuccessError
                  msg={this.state.updateMsg}
                  msgDetail={this.state.updateMsgDetail}
                  updateSuccess={this.state.updateSuccess}
                  success={() => {
                    const id = `${this.state.partnerCompanyId}.${
                      this.state.companyBranchId
                    }.${this.state.partnerUserId}`;
                    _masterSlideLoader.show('PartnerUserPreview', {
                      state: { id },
                    });
                  }}
                  error={() => this.setState({ showModal: false })}
                  labelBtnError={messageUtility.getMessage('I-000-017')}
                  multilineText={true}
                />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerUserEdit.jsx